/* eslint-disable radix */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react";
import { EditorBlock } from "draft-js";

import { DRAFT } from "../../constants";

const getStyleList = block => {
  const listReactStyles = {};
  let listStyles = block.data.get("elementStyle") || "";
  if (Object.entries(listStyles).length !== 0) {
    listStyles = listStyles
      .replace("text-align", "textAlign")
      .replace("margin-left", "marginLeft")
      .replace("text-indent", "textIndent");
    listStyles = listStyles.split(";");
    for (let i = 0; i < listStyles.length; i += 1) {
      const style = listStyles[i];
      const [key, value] = style.split(":");
      listReactStyles[key] = value;
    }
  }
  return listReactStyles;
};

class HeaderOneComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <h1 id="header-one" className="header-one" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </h1>
    );
  }
}

class HeaderTwoComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <h2 id="header-two" className="header-two" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </h2>
    );
  }
}
class HeaderThreeComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <h3 id="header-three" className="header-three" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </h3>
    );
  }
}
class HeaderFourComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <h4 id="header-four" className="header-four" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </h4>
    );
  }
}

class UnStyledParagraph extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <div id="styledpara" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </div>
    );
  }
}

class ParaListComponent extends Component {
  render() {
    const listReactStyles = getStyleList(this.props.block);
    return (
      <div id="listitem" style={listReactStyles}>
        <EditorBlock {...this.props} />
      </div>
    );
  }
}

class OrderedListComponent extends Component {
  LIST_TYPE = DRAFT.ORDERED_LIST_TYPES;

  render() {
    const { block, contentState } = this.props;
    const listReactStyles = getStyleList(block);

    const type = block.getType();
    // get the list level
    const listLevel = parseInt(type.split("-")[2]);
    const listStyles = {
      display: "list-item",
      listStyleType: this.LIST_TYPE[(listLevel - 1) % this.LIST_TYPE.length],
    };

    listReactStyles.marginLeft = `${listLevel * DRAFT.DRAFT_TAB_LENGTH - 16}px`;
    let count = 1;
    let prevBlock = contentState.getBlockBefore(block.getKey());

    // count proper
    if (
      prevBlock &&
      prevBlock.getType().includes("list") &&
      type.includes("list")
    ) {
      while (prevBlock && prevBlock.getType().includes("list")) {
        // check if prev level should be continued/discontinued
        if (
          prevBlock &&
          parseInt(prevBlock.getType().split("-")[2]) === listLevel - 1
        ) {
          break;
        }
        if (prevBlock && prevBlock.getType() === type) {
          // get that last count
          count += 1;
        }

        prevBlock = contentState.getBlockBefore(prevBlock.getKey());
      }
    }

    return (
      // <ul className={`ordered-list ${type}`}>
      //   <li id="ordered-list" value={count}>
      //     <EditorBlock {...this.props} />
      //   </li>
      // </ul>

      <ol className={`ordered-list ${type}`} style={listReactStyles}>
        <li id="ordered-list" style={listStyles} value={count}>
          <EditorBlock {...this.props} />
        </li>
      </ol>
    );
  }
}

class UnorderedListComponent extends Component {
  LIST_TYPE = DRAFT.UNORDERED_LIST_TYPES;

  render() {
    const listReactStyles = getStyleList(this.props.block);
    const type = this.props.block.getType();

    // get the list level
    const listLevel = parseInt(type.split("-")[2]);

    const listStyles = {
      display: "list-item",
      listStyleType: this.LIST_TYPE[listLevel % this.LIST_TYPE.length],
    };

    listReactStyles.marginLeft = `${listLevel * DRAFT.DRAFT_TAB_LENGTH - 16}px`;
    return (
      <ul className={`unordered-list ${type}`} style={listReactStyles}>
        <li id="unordered-list" style={listStyles}>
          <EditorBlock {...this.props} />
        </li>
      </ul>
    );
  }
}
const blockTypeMapping = {
  "header-one": HeaderOneComponent,
  "header-two": HeaderTwoComponent,
  "header-three": HeaderThreeComponent,
  "header-four": HeaderFourComponent,
  unstyled: UnStyledParagraph,
  plist: ParaListComponent,
};

const customBlockRenderer = (
  getEditorState,
  onChange,
  readOnly,
) => contentBlock => {
  const type = contentBlock.getType();
  let component;
  if (type in blockTypeMapping) {
    component = blockTypeMapping[type];
  } else if (type.startsWith("unordered-list")) {
    component = UnorderedListComponent;
  } else if (type.startsWith("ordered-list")) {
    component = OrderedListComponent;
  }
  if (component) {
    return {
      component,
      editable: !readOnly,
      props: {
        onChange,
        getEditorState,
      },
    };
  }
  return null;
};

export default customBlockRenderer;



// WEBPACK FOOTER //
// ./src/components/CustomRevvEditor/BlockStyling.js